<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> お支払一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
        </div>
        <div class="card-body">
          <form novalidate name="myListForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label" for="year_pay">お支払日</label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <select class="form-control" id="year_pay" name="year_pay"
                              [(ngModel)]="selectYear" (ngModelChange)="updateSelectSettleMonth()">
                        <option [ngValue]="null">-- すべて --</option>
                        @for (ypo of yearPayOption; track ypo.id) {
                          <option [ngValue]="ypo">{{ ypo.name }}</option>
                        }
                      </select>
                    </div>
                    <div><span>&nbsp;</span></div>
                    <div class="bisected-input">
                      <select class="form-control" id="month_pay" name="month_pay"
                              [(ngModel)]="selectMonth" (ngModelChange)="updateSelectSettleMonth()">
                        <option [ngValue]="null">-- すべて --</option>
                        @for (mpo of monthPayOption; track mpo.id) {
                          <option [ngValue]="mpo">{{ mpo.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label" for="status">お支払状況</label>
                  <select class="form-control" id="status" name="status"
                          [(ngModel)]="statusFilter" (ngModelChange)="applyFilter()">
                    <option [ngValue]="null">-- すべて --</option>
                    @for (so of statusOption; track so.id) {
                      <option [ngValue]="so">{{ so.name }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <label class="col-form-label" for="keyword">キーワード検索</label>
                  <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword"
                         class="form-control" placeholder="明細など"
                         (ngModelChange)="limitBegin = 0; applyFilter()">
                </div>
              </div>
              <div class="col-md-4 d-flex align-items-end">
                <div class="form-group">
                  @if (showListTable) {
                    <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                      <i class="fa s-icon-backspace"></i>&nbsp;クリア
                    </button>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-body">
          <ul class="pagination pull-right">
            @for (pager of pagerPages; track pager) {
              <li [class.active]="pager === currentPage">
                <a href="" class="pager-item" (click)="pagerClick(pager); $event.preventDefault()">{{ pager + 1 }}</a>
              </li>
            }
          </ul>
          @if (!searching && filteredItems.length === 0) {
            <span>該当するデータはありません</span>
          }
          <div class="table-responsive">
            @if (showListTable) {
              <table class="table table-bordered table-sm table-hover">
                @if (filteredItems.length > 0) {
                  <thead>
                    <tr>
                      <th width="90px">お支払状況</th>
                      <th class="d-md-none d-table-cell" width="200px">お支払内容</th>
                      <th class="d-none d-md-table-cell" width="150px">店舗名</th>
                      <th class="d-none d-md-table-cell" width="150px">お支払日</th>
                      <th class="d-none d-md-table-cell" width="170px">課金タイプ</th>
                      <th class="d-none d-md-table-cell" width="80px">金額</th>
                      <th class="d-none d-md-table-cell" width="130px">支払方法</th>
                      <th class="d-none d-md-table-cell" width="80px">領収書</th>
                    </tr>
                  </thead>
                }
                <tbody>
                  @for (item of pagedItems; track item.id) {
                    <tr>
                      <td>
                        <div class="border-0 d-flex flex-column bd-highlight text-center">
                          @if (item.status === 0) {
                            <span class="text-warning" title="請求予定"><i class="fa s-icon-schedule fa-2x fa-fw"></i></span>
                            <small>請求予定</small>
                          }
                          @if (item.status === 1) {
                            <span class="text-secondary" title="削除済"><i class="fa s-icon-close fa-2x fa-fw"></i></span>
                            <small>削除済</small>
                          }
                          @if (item.status === 2) {
                            <span class="text-warning" title="請求確定"><i class="fa s-icon-waiting fa-2x fa-fw"></i></span>
                            <small>請求確定</small>
                          }
                          @if (item.status === 3) {
                            <span class="text-primary" title="承認済"><i class="fa fa-gavel fa-2x fa-fw"></i></span>
                            <small>承認済</small>
                          }
                          @if (item.status === 4) {
                            <span class="text-secondary" title="キャンセル済"><i class="fa fa-times-circle fa-2x fa-fw"></i></span>
                            <small>キャンセル済</small>
                          }
                          @if (item.status === 5) {
                            <span class="text-success" title="支払済"><i class="fa s-icon-finished fa-2x fa-fw"></i></span>
                            <small>支払済</small>
                          }
                          @if (item.status === 6) {
                            <span class="text-danger" title="未納"><i class="fa s-icon-attention fa-2x fa-fw"></i></span>
                            <small>未納</small>
                          }
                          @if (item.status === 7) {
                            <span class="text-success" title="払い戻し済"><i class="fa s-icon-back fa-2x fa-fw"></i></span>
                            <small>払い戻し済</small>
                          }
                          @if (item.status === 8) {
                            <span class="text-secondary" title="請求停止"><span class="material-icons-outlined fa-2x fa-fw">do_disturb_on</span></span>
                            <small>請求停止</small>
                          }
                          @if (item.status === 9) {
                            <span class="text-success" title="受け取り"><i class="fa s-icon-cashPay fa-2x fa-fw"></i></span>
                            <small>受け取り</small>
                          }
                        </div>
                      </td>
                      <td class="d-md-none d-table-cell" style="padding: 1rem 0.75rem">
                        <span class="d-block">{{ item.title }}</span>
                        <span class="d-block">{{ formatCurrency(item.amount) }}</span>
                        <hr>
                        <span class="d-block">お支払日: </span>
                        <span class="d-block" style="padding-left: 0.5rem">{{ item.settleDate }}</span>
                        @if (item.paymentMethod === 0) {
                          <span class="d-block" style="padding-left: 0.5rem">口座振替</span>
                        }
                        @if (item.paymentMethod === 1) {
                          <span class="d-block" style="padding-left: 0.5rem">クレジット</span>
                        }
                        @if (item.status === 5 || item.status === 9) {
                          <button type="button" class="mt-1 mb-1 btn btn-success btn-sm"
                                  style="margin-top: 1rem !important"
                                  data-toggle="modal" data-target="#showReceiptModal"
                                  (click)="getReceipt(item)" title="領収書">
                            <i class="fa s-icon-dawnload fa-fw"></i> 領収書ダウンロード
                          </button>
                        }
                      </td>
                      <td class="d-none d-md-table-cell">{{ item.studio?.name }}</td>
                      <td class="d-none d-md-table-cell">{{ item.settleDate }}</td>
                      <td class="d-none d-md-table-cell">{{ item.title }}</td>
                      <td class="d-none d-md-table-cell"><span class="pull-right">{{ formatCurrency(item.amount) }}</span></td>
                      <td class="d-none d-md-table-cell">
                        @if (item.paymentMethod === 0) { <span>口座振替</span> }
                        @if (item.paymentMethod === 1) { <span>クレジット</span> }
                      </td>
                      <td class="text-center d-none d-md-table-cell">
                        @if (item.status === 5 || item.status === 9) {
                          <button type="button" class="mt-1 mb-1 btn btn-success btn-sm"
                                  data-toggle="modal" data-target="#showReceiptModal"
                                  (click)="getReceipt(item)" title="領収書">
                            <i class="fa s-icon-dawnload fa-fw"></i>
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
          <ul class="pagination pull-right">
            @for (pager of pagerPages; track pager) {
              <li [class.active]="pager === currentPage">
                <a href="" class="pager-item" (click)="pagerClick(pager); $event.preventDefault()">{{ pager + 1 }}</a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Receipt Modal -->
  <div class="modal fade" id="showReceiptModal" tabindex="-1" role="dialog"
       aria-labelledby="showReceiptModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div id="transactionReceipt">
          <div class="modal-header">
            <h3 class="modal-title font-weight-bold receipt-title" id="showReceiptModalLabel">領収書</h3>
          </div>
          <div class="modal-body">
            <div class="col-md-12 clearfix">
              <div class="float-right">
                <span class="font-weight-bold">No.&nbsp;</span>
                <span>{{ singleTransaction.id }}</span>
              </div>
            </div>
            <div class="col-md-12 clearfix">
              <div class="float-right">
                <span class="font-weight-bold">発行日&nbsp;</span>
                @if (singleTransaction.capturedAt != null) {
                  <span>{{ singleTransaction.capturedAt | date:'yyyy年M月d日' }}</span>
                }
                @if (singleTransaction.capturedAt == null) {
                  <span>{{ singleTransaction.createdAt | date:'yyyy年M月d日':'+0900' }}</span>
                }
              </div>
            </div><br />
            <div class="col-md-12 clearfix">
              <span class="h3"><p><span class="border-bottom border-gray-900">{{ member.lastName }}&nbsp;{{ member.firstName }}&nbsp;様</span></p></span>
            </div><br />
            <div class="col-md-12 bg-light clearfix">
              <p class="h2 text-center font-weight-bold">
                {{ formatCurrency(singleTransaction.amount) }}&ndash;
              </p>
            </div>
            <div class="col-md-12 clearfix">
              <p class="text-center">
                但:「{{ singleTransaction.title }}」代金として<br />
                上記正に領収いたしました。
              </p>
            </div>
            <div class="row">
              <ul class="col-md-5 ml-md-auto corporate-seal" style="list-style: none;word-wrap: break-word;">
                <li class="font-weight-bold">内訳(税率{{ (singleTransaction.product?.taxRate?.rate ?? 0) * 100 }}%)</li>
                <li class="font-weight-bold border-top d-flex justify-content-between">
                  <span>税抜金額</span>
                  <span>{{ formatCurrency((singleTransaction.amount ?? 0) - (singleTransaction.taxAmount ?? 0)) }}&ndash;</span>
                </li>
                <li class="font-weight-bold border-top d-flex justify-content-between">
                  <span>消費税等</span>
                  <span>{{ formatCurrency(singleTransaction.taxAmount ?? 0) }}&ndash;</span>
                </li>
                <li class="font-weight-bold border-top"></li>
              </ul>
              <div class="col-md-7 ml-md-auto corporate-seal">
                @if (studio.owner?.id !== 1) {
                  <span class="font-weight-bold">{{ studio.owner?.name }}<br/></span>
                  <span class="font-weight-bold">{{ studio.receiptName || studio.name }}</span>
                }
                @if (studio.owner?.id === 1) {
                  <span class="font-weight-bold">株式会社スマートフィットネス</span>
                }
                @if (studio.owner?.invoiceRegistrationNumber) {
                  <br/>登録番号T{{ studio.owner.invoiceRegistrationNumber }}
                }
                <br/>
                <span>〒&nbsp;{{ member.studio?.zip }}</span>
                <ul style="list-style: none;padding: 0;word-wrap: break-word;">
                  <li>
                    {{ member.studio?.province }}@if ((member.studio?.city?.length || 0) > 15) {<br/>}{{ member.studio?.city }}@if ((member.studio?.province?.length || 0) + (member.studio?.city?.length || 0) + (member.studio?.area?.length || 0) > 18) {<br/>}{{ member.studio?.area }}@if ((member.studio?.area?.length || 0) + (member.studio?.address?.length || 0) > 18) {<br/>}{{ member.studio?.address }}
                  </li>
                  <li>TEL:&nbsp;{{ member.studio?.phone }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" data-dismiss="modal">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          @if (singleTransaction.isDownloadedReceipt == 0) {
            <button class="btn btn-success" type="button" data-dismiss="modal"
                    (click)="downloadReceipt(singleTransaction.id, member.memberCode)">
              <i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード
            </button>
          }
          @if (singleTransaction.isDownloadedReceipt == 1) {
            <button class="btn btn-success" type="button" data-dismiss="modal" disabled>
              <i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード済
            </button>
          }
        </div>
        <div class="modal-footer pt-0">
          <p class="mb-0">※ 領収書一枚につき、一度だけPDF形式のダウンロードが可能です。</p>
        </div>
      </div>
    </div>
  </div>
</div>
